import React from 'react';

export const YourLocation = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='72' height='72' viewBox='0 0 72 72' fill='none'>
        <g clip-path='url(#clip0_1753_150654)'>
            <path
                d='M36 71.1778C50.6093 71.1778 62.4526 68.6311 62.4526 65.4895C62.4526 62.348 50.6093 59.8013 36 59.8013C21.3906 59.8013 9.54736 62.348 9.54736 65.4895C9.54736 68.6311 21.3906 71.1778 36 71.1778Z'
                fill='#FFDA45'
            />
            <path
                d='M62.4519 65.4895C62.4519 62.348 50.6088 59.8013 35.9993 59.8013C33.569 59.8013 31.216 59.8721 28.9805 60.0041L33.932 67.2886C34.0701 67.4919 34.2314 67.6659 34.4084 67.8125L37.7607 71.1649C51.5486 70.9699 62.4519 68.5038 62.4519 65.4895Z'
                fill='#FFDA45'
            />
            <path
                d='M64.9925 29.5042C64.9925 13.4919 52.012 0.51123 35.9996 0.51123C20.0569 0.51123 7.16774 13.2649 7.00784 29.2069C6.88715 41.2472 14.1072 51.6142 24.4661 56.1104C26.1995 56.8628 27.6823 58.0943 28.7446 59.6572L33.9321 67.2887C34.9241 68.7479 37.0747 68.7479 38.0667 67.2887L43.254 59.6573C44.313 58.0993 45.788 56.8664 47.5166 56.1175C57.7987 51.6618 64.9925 41.4239 64.9925 29.5042Z'
                fill='#FF7044'
            />
            <path
                d='M36.0004 66.938C35.8325 66.938 35.4112 66.893 35.1279 66.4762L29.9405 58.8444C28.7206 57.0498 27.0268 55.6459 25.0423 54.7847C14.8536 50.3622 8.34215 40.3278 8.45356 29.2208C8.52699 21.8942 11.421 15.0353 16.6024 9.90723C21.7832 4.77974 28.673 1.95557 36.0004 1.95557C51.1905 1.95557 63.5488 14.3138 63.5488 29.5039C63.5488 40.4943 57.0307 50.4201 46.9432 54.7914C44.9701 55.6464 43.2816 57.048 42.0603 58.8447L36.8729 66.4763C36.5896 66.893 36.1683 66.938 36.0004 66.938Z'
                fill='#FC4326'
            />
            <path
                d='M35.9997 47.7284C46.065 47.7284 54.2245 39.5689 54.2245 29.5036C54.2245 19.4383 46.065 11.2788 35.9997 11.2788C25.9344 11.2788 17.7749 19.4383 17.7749 29.5036C17.7749 39.5689 25.9344 47.7284 35.9997 47.7284Z'
                fill='#FF7044'
            />
            <path
                d='M64.0864 36.7223L46.7714 19.4073C44.0777 16.535 40.249 14.7397 36.0004 14.7397C27.8464 14.7397 21.2363 21.3499 21.2363 29.5038C21.2363 33.7524 23.0315 37.5812 25.9039 40.2748L44.152 58.5229C45.0897 57.4974 46.2335 56.6733 47.5177 56.117C55.6498 52.593 61.849 45.4516 64.0864 36.7223Z'
                fill='#F92814'
                fill-opacity='0.66'
            />
            <path
                d='M36.0004 44.2679C44.1544 44.2679 50.7645 37.6578 50.7645 29.5038C50.7645 21.3498 44.1544 14.7397 36.0004 14.7397C27.8464 14.7397 21.2363 21.3498 21.2363 29.5038C21.2363 37.6578 27.8464 44.2679 36.0004 44.2679Z'
                fill='#F9F7FC'
            />
        </g>
        <defs>
            <clipPath id='clip0_1753_150654'>
                <rect width='70.6667' height='70.6667' fill='white' transform='translate(0.666504 0.51123)' />
            </clipPath>
        </defs>
    </svg>
);
